/**
 * TpinScreens - picks the TPIN-first screen the URL names: the overview
 * (`/tpin/{tin}`) or one branch (`/tpin/{tin}/branch/{dbName}`). The decision is
 * one pure parse (`parseTpinPath`); `useRoute` is read only so a navigation
 * re-renders this component with the new location.
 */

import { useRoute } from '@components/route'
import { parseInvoicePath, parseTpinPath } from '@domain/tpinPaths'
import { InvoiceDetailPage } from './InvoiceDetailPage'
import { TpinBranchPage } from './TpinBranchPage'
import { TpinDashPage } from './TpinDashPage'

/** True for the two paths this component renders; the app's unknown-path rewrite uses it too. */
export function isTpinScreenPath(pathname: string): boolean {
  return parseTpinPath(pathname) !== null || parseInvoicePath(pathname) !== null
}

export function TpinScreens() {
  useRoute()
  const invoice = parseInvoicePath(window.location.pathname)
  if (invoice !== null) return <InvoiceDetailPage tin={invoice.tin} dbName={invoice.dbName} rectNo={invoice.rectNo} />
  const screen = parseTpinPath(window.location.pathname)
  if (screen === null) return null
  return screen.dbName === null ? (
    <TpinDashPage tin={screen.tin} />
  ) : (
    <TpinBranchPage tin={screen.tin} dbName={screen.dbName} />
  )
}
